import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import cross from '../../../assets/cross.svg';
import plus from '../../../assets/plus.svg';
import updateIcon from '../../../assets/update.png';
import apiv2 from '../../../config/apiv2';
import { STATUS } from '../../../contants/statusDatasource';
import { successNotif } from '../../../helpers/notyf';
import Alert from '../Alert/Alert';
import Button from '../Button/Button';
import Input from '../Input/Input';
import DashboardTable from './DashboardTable';
import DataSourcesTable from './DataSourcesTable';
import InvoicesTable from './InvoicesTable';
import css from './Tables.module.css';

const Table = ({
  data,
  search,
  filter,
  setFilter,
  handleSearch,
  handleAddSource,
  handleDisconnect,
  handleSelectCampaigns,
  handleAuth,
  isLoading,
  type,
}) => {
  const formater = (title, btn) => {
    if (title) {
      if (type === 'data') return 'Data Sources';
      // if (type === 'accounts') return 'Accounts';
      // if (type === 'campaigns') return 'Campaigns';
    } else if (btn) {
      if (type === 'budgetData') return 'Add';
      if (type === 'data') return 'Add Data Sources';
    }
  };
  const [historyData, setHistoryData] = useState('');
  const {choosenSources, accounts, campaigns} = useSelector(
    state => state.createBudget,
  );
  const choosenAccounts = useSelector(
    state => state.createBudget.choosenAccounts,
  );
  const { isNewDataSource } = useSelector(state => state.dataSource);

  useEffect(() => {
    if (type === 'budgetData') {
      apiv2
        .GET_HISTORY_SOURCES()
        .then(res => setHistoryData(res.data.last_sync_datetime))
        .catch(err => err);
    }
    if (type === 'accounts') {
      if (choosenSources[0]?.id) {
        apiv2
          .GET_HISTORY_ACCOUNTS(choosenSources[0]?.id)
          .then(res => setHistoryData(res.data.last_sync_datetime))
          .catch(err => console.log(err));
      }
    }
    if (type === 'campaigns') {
      if (choosenAccounts[0]?.id) {
        apiv2
          .GET_HISTORY_COMPAIGNS(choosenAccounts[0]?.source?.id, choosenAccounts[0]?.id)
          .then(res => setHistoryData(res.data.last_sync_datetime))
          .catch(err => err);
      }
    }
  }, [type]);

  const haveDisconnectDataSource =
    type === 'data' &&
    data?.find(dataSource => dataSource.status !== STATUS.ACTIVE);

  const isShowSyncButton =
    type === 'budgetData' ||
    (type === 'accounts' && choosenSources[0]?.id && accounts.length > 0) ||
    (type === 'campaigns' && choosenAccounts[0]?.id && campaigns.length > 0);
  const isShowLastUpdated =
    (type === 'budgetData' ||
      (type === 'accounts' && choosenSources[0]?.id && accounts.length > 0) ||
      (type === 'campaigns' &&
        choosenAccounts[0]?.id &&
        campaigns.length > 0)) &&
    !isNewDataSource &&
    historyData !== '';

  const handleClearFilters = () => {
    setFilter('');
  };

  const updateFunc = () => {
    if (type === 'budgetData') {
      apiv2.GET_SOURCES_DATA().then(() => {
        successNotif();
        apiv2
          .GET_HISTORY_SOURCES()
          .then(res => setHistoryData(res.data.last_sync_datetime))
          .catch(res => console.log({ res }));
      });
    }
    if (type === 'accounts') {
      apiv2.GET_SOURCES_ACCOUNT(choosenSources[0].id).then(() => {
        successNotif();
        apiv2
          .GET_HISTORY_ACCOUNTS(choosenSources[0].id)
          .then(res => setHistoryData(res.data.last_sync_datetime));
      });
    }
    if (type === 'campaigns') {
      apiv2
        .GET_SOURCES_COMPAIGNS(choosenAccounts[0].source.id, choosenAccounts[0].id)
        .then(() => {
          successNotif();
          apiv2
            .GET_HISTORY_COMPAIGNS(choosenAccounts[0].source.id, choosenAccounts[0].id)
            .then(res => setHistoryData(res.data.last_sync_datetime));
        });
    }
  };

  return (
    <>
      {type !== 'confirmBudget' && (
        <header
          className={`${css.header} ${
            type === 'data' ||
            type === 'budgetData' ||
            type === 'accounts' ||
            type === 'campaigns'
              ? ''
              : css.mb0
          } ${
            type === 'campaigns' || type === 'accounts' || type === 'budgetData'
              ? css.sticky
              : ''
          }`}
        >
          {(type === 'data' ||
            type === 'budgetData' ||
            type === 'accounts' ||
            type === 'campaigns') && (
            <div className={css.container}>
              <div className={css.headerCampaigns}>
                <h1 className={css.title}>{formater(true)}</h1>
                {type === 'data' && haveDisconnectDataSource && (
                  <div className={css.wrapperAlert}>
                    <Alert
                      type="warning"
                      message="Access token has expired. Resync the data source to regain access."
                    />
                  </div>
                )}

                {type !== 'data' && (
                  <Input
                    styled="search"
                    type="text"
                    placeholder="Search..."
                    style={{ width: 240 }}
                    value={search}
                    onChange={handleSearch}
                  />
                )}
              </div>
              {type === 'campaigns' && filter && (
                <div className={css.selectedFilter}>
                  <span className={css.selectedText}>{filter}</span>
                  <img src={cross} onClick={handleClearFilters} />
                </div>
              )}
            </div>
          )}
          {isShowSyncButton && (
            <>
              <div className={css.updateWrapper} onClick={updateFunc}>
                <img src={updateIcon} className={css.icon_update} />
                <span className={css.updateText}>Update</span>
              </div>
            </>
          )}
          {(type === 'data' || type === 'budgetData') && (
            <Button
              styled="addSource"
              onClick={handleAddSource}
              style={{
                width: 200,
              }}
            >
              <div className={css.btnWrapper}>
                <img alt="add" src={plus} className={css.addImg} />
                <span className={css.addText}>{formater(null, true)}</span>
              </div>
            </Button>
          )}

          {type === 'campaigns' && (
            <Button styled="addSource" onClick={handleSelectCampaigns}>
              <div className={css.btnWrapper}>
                <span className={css.addText}>Add</span>
              </div>
            </Button>
          )}
        </header>
      )}
      {type === 'data' && (
        <DataSourcesTable
          data={data}
          handleDisconnect={handleDisconnect}
          handleAuth={handleAuth}
          type={type}
        />
      )}
      {isShowLastUpdated && (
        <div className={css.lastUpdate}>
          <div>Last sync:</div>
          {moment(historyData).fromNow()}
        </div>
      )}
      {type === 'budgetData' && (
        <DataSourcesTable data={data} handleAuth={handleAuth} type={type} />
      )}
      {(type === 'accounts' || type === 'campaigns') && (
        <>
          <DataSourcesTable
            data={data}
            type={type}
            isLoading={isLoading}
            filter={filter}
            setFilter={setFilter}
            clearSearchData={() => handleSearch('')}
          />
        </>
      )}
      {type === 'confirmBudget' && <DataSourcesTable type={type} />}
      {(type === 'clients-budget-pacing' ||
        type === 'clients-performance' ||
        type === 'budgets-budget-pacing' ||
        type === 'budgets-performance' ||
        type === 'campaigns-budget-pacing' ||
        type === 'campaigns-performance') && <DashboardTable type={type} />}
      {type === 'invoices' && <InvoicesTable data={data} />}
    </>
  );
};

export default Table;
